/**
 * Error event name.
 * @constant {string}
 */
const errorEvent = 'error';

/**
 * Event name for a ping message.
 * @constant {string}
 */
const pingEvent = 'ping';

/**
 * Event name for a pong message.
 * @constant {string}
 */
const pongEvent = 'pong';

/**
 * Event name for joining a room.
 * @constant {string}
 */
const joinRoomEvent = 'joinRoom';

/**
 * Event name for leaving a room.
 * @constant {string}
 */
const leaveRoomEvent = 'leaveRoom';

/**
 * Event name for system state updates.
 * @constant {string}
 */
const systemStateEvent = 'systemStateEvent';

/**
 * Event name for leaving a session (two-way).
 * @constant {string}
 */
const leaveSessionEvent = 'leaveSession';

/**
 * Event name for joining a session (two-way).
 * @constant {string}
 */
const joinSessionEvent = 'joinSessionEvent';

/**
 * Event name for a partner joining a session (one-way).
 * @constant {string}
 */
const partnerJoinSessionEvent = 'partnerJoinSession';

/**
 * Event name for a partner leaving a session (one-way).
 * @constant {string}
 */
const partnerLeaveSessionEvent = 'partnerLeaveSession';

export {
  errorEvent,
  pingEvent,
  pongEvent,
  partnerLeaveSessionEvent,
  partnerJoinSessionEvent,
  joinSessionEvent,
  leaveSessionEvent,
  joinRoomEvent,
  leaveRoomEvent,
  systemStateEvent,
};
